/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 10:30:48
 * @LastEditTime: 2022-06-06 15:57:04
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/ReportSubscriptionDetail/ReportsFormat/index.tsx
 */
import { Label, RadioGroup, RadioItem, Select } from '@/src/components/Antd';
import { IExportFormat } from '@/src/types/common/report';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
import {
  languageLabel,
  languageList,
} from '@/locale/IntlProvider/IntlProvider';
const ReportsFormat = ({ disabled }: { disabled?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      titleClassName={css.titleClassName}
      title={getI18n(
        'reportSubscription.reportSubscriptionDetail.reportsFormat.title',
      )}>
      <Form.Item
        name='exportFormat'
        initialValue={IExportFormat.Excel}
        label={
          <Label
            title={getI18n(
              'reportSubscription.reportSubscriptionDetail.reportsFormat.export_As',
            )}
          />
        }
        labelCol={{ span: 24 }}>
        <RadioGroup className={css.exportFormat} disabled={disabled}>
          <RadioItem value={IExportFormat.Excel}>
            {getI18n(
              'reportSubscription.reportSubscriptionDetail.reportsFormat.excel',
            )}
          </RadioItem>
          <RadioItem value={IExportFormat.CSV}>
            {getI18n(
              'reportSubscription.reportSubscriptionDetail.reportsFormat.csv',
            )}
          </RadioItem>
        </RadioGroup>
      </Form.Item>
      <Form.Item
        name='templateLang'
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 8 }}
        label={
          <Label
            title={getI18n('reports.reportpagecommon.reportTemplateLanguage')}
          />
        }>
        <Select
          optionsList={languageList.map((item) => ({
            value: item,
            label: languageLabel[item],
          }))}></Select>
      </Form.Item>
    </SectionWrapper>
  );
};

export default ReportsFormat;
